<template>
   <transition :name="loadSettings.animationStyle">
    <div v-if="loadSettings.animationStyle" class="loadwrap">
      <p>{{loadSettings.message}}</p>
      <div class="hollow-dots-spinner">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
      </div>
    </div>
   </transition>
</template>

<script>
export default {
  name: "LoadAnimation",
  props: ['loadSettings'],
  data() {
    return {

    }
  },
};
</script>


<style scoped>
/*  Animation available settings: 'slide' , 'zoom', 'fade' , fell free to add more */
.loadwrap{
  display: block;
  width: 100%;
} 
.hollow-dots-spinner,
.hollow-dots-spinner *, p {
  box-sizing: border-box;
}
p{
  height: 15px;
  margin: 0 auto;
  text-align: center;
   margin-bottom: 10px;
}
.hollow-dots-spinner {
  height: 15px;
  width: calc(30px * 3);
  margin: 0 auto;
  margin-bottom: 10px;
}

.hollow-dots-spinner .dot {
  width: 15px;
  height: 15px;
  margin: 0 calc(15px / 2);
  border: calc(15px / 5) solid var(--o-primary);
  border-radius: 50%;
  float: left;
  transform: scale(0);
  animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;
}

.hollow-dots-spinner .dot:nth-child(1) {
  animation-delay: calc(300ms * 1);
}

.hollow-dots-spinner .dot:nth-child(2) {
  animation-delay: calc(300ms * 2);
}

.hollow-dots-spinner .dot:nth-child(3) {
  animation-delay: calc(300ms * 3);
}

@keyframes hollow-dots-spinner-animation {
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  opacity: 0;
  transform: translateY(-30px);
}
.slide-leave-to {
  opacity: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.zoom-enter-active {
  animation: zoomIn .3s;
}
.zoom-leave-active {
  animation: zoomIn 0.3s reverse;
}
</style>